import { Chip, Divider, SxProps, ChipProps, Typography, Box, } from "@mui/material";

type IDividerCore = ChipProps & {
  title?: string;
  sxStyle?: SxProps;
  textAlign?: "left" | "right" | "center";
  button?: React.ReactNode;
};

export const DividerCore = ({
  title,
  sxStyle,
  textAlign = "center",
  button,
  ...props
}: IDividerCore) => {
  return (
    <Box
      sx={{
        margin: "20px 0",
        background: "#d6d6d66a",
        borderRadius: "8px",
        padding: "4px 12px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        ...sxStyle,
      }}
      {...props}
    >
      <Typography sx={{ color: (theme) => theme.palette.text.primary }}>
        {title}
      </Typography>

      {button}
    </Box>
  );
};
